export default __webpack_public_path__ + "static/media/prima-nota-dark.c9e54d56.svg";